import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { StoreForm } from "@modules/stores/components/StoreForm";
import { useStoreCreateForm } from "./controller";

export const StoreCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useStoreCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <StoreForm />
      </FormProvider>
    </Create>
  );
});
